import type { ConfigEnv } from './types';

class Config {

  SENTRY_URL: string = '';
  SENTRY_ENV: string = '';
  SENTRY_IGNORE_PAGES: string[] = [];
  OSS_BUCKET: string = '';
  OSS_ENDPOINT: string = '';
  BACKEND_HOST: string = '';
  BACKEND_MAIN_HOST: string = '';
  BACKEND_TOOLKIT_HOST: string = '';
  BACKEND_HARNESS_HOST: string = '';
  BACKEND_XUNDIAN_HOST: string[] = [];

  init(config: ConfigEnv): void {
    Object.assign(this, config);
  }

}

export const config = new Config();
export const CONFIG = config;
